module.exports = __webpack_public_path__ + "media/images/custom_page/limyoungmin_event/limyoungmin-event-ko-4b17d99151d3c523dfa4ccd19af304bf.png";